const tabs = {
  init: function() {
    $('.contact-info-tab').click(function(event) {

      $('.contact-info-tab').removeClass('current');
      $('.contact-info-content').hide();

      event.preventDefault();

      $($(this).addClass('current').attr('href')).fadeIn(400);

    });
  }
}
tabs.init();

const forms = {

  submit: function(event) {

    event.preventDefault();
    forms.current = $(this);

    grecaptcha.ready(function() {
      grecaptcha.execute('6LdS0qcUAAAAAPWjC89PRMJsj0gNFnlBywlucxEW', {action: 'submit'}).then(function(token) {
        forms.current.find('button').addClass('disabled').find('i').attr('class', 'fa fa-spinner fa-pulse');

        forms.current.find('.invalid-feedback').remove();
        forms.current.find('.is-invalid').removeClass('is-invalid');
        forms.current.find('[name="token"]').val(token);

        $.ajax({
          url: forms.current.attr('action'),
          type: 'POST',
          data: forms.current.serializeArray(),
        })
        .done(function(response) {

          const responseBox = $('<div>').addClass('row align-items-center').height(forms.current.height()).hide().append(
            $('<div>').addClass('col-12 text-center').append(
              $('<div>').addClass('py-2').html($('<i>').addClass('fa fa-check-circle text-success fa-5x'))
            ).append(
              $('<h4>').addClass('text-stronger text-dark mt-2').html(response.title)
            ).append(
              $('<div>').html(response.message)
            )
          );

          forms.current.hide();
          forms.current.parent().append(responseBox);
          responseBox.fadeIn(400);
        })
        .fail(function(xhr) {
          response = xhr.responseJSON.errors;
          if(response){
            Object.keys(response).forEach(function(i){
              const parent = forms.current.find(`[name="${i}"]`).parent();

              parent.find('.form-control, .custom-select').addClass('is-invalid');

              parent.append(
                $('<span>').addClass('text-danger small invalid-feedback').text(response[i])
              )
            });

            $('.is-invalid').first().focus();
          }
          else{
            forms.current.prepend(
              $('<div>').addClass('col-12').append(
                $('<div>').addClass(`alert alert-danger`).text(xhr.status + ' - ' + xhr.statusText).append(
                  $('<button>').attr({'type': 'button', 'data-dismiss': 'alert', 'class': 'close' }).append($('<span>').html('&times;'))
                )
              )).find('.alert button').focus().blur();
          }
        })
        .always(function() {
          forms.current.find('button').removeClass('disabled').find('i').removeAttr('class');
        });
      });
    });

        

  },

  init:function() {

    $('.contact-form').submit(forms.submit);

  }

}
forms.init();

$('.btn-join').click(function() {
  $(window).scrollTop($('.signup-title').offset().top - 65);
});